import Glide, {
  Controls,
  Swipe,
  Breakpoints,
} from '@glidejs/glide/dist/glide.modular.esm';

export function setupSliders() {
  Array.from(document.querySelectorAll('.js-slider')).forEach((slider) => {
    const sliderType = slider.dataset.sliderType
      ? slider.dataset.sliderType
      : 'slider';
    const tabletSlides = slider.dataset.tabletSlides
      ? slider.dataset.tabletSlides
      : 1;

    const initialisedSlider = new Glide(slider, {
      type: sliderType,
      perView: tabletSlides,
      breakpoints: {
        767: { perView: 1 },
      },
    });

    // Wait a tiny bit before mounting so that slider width gets calculated properly
    setTimeout(() => {
      initialisedSlider.mount({ Controls, Swipe, Breakpoints });
    }, 500);
  });
}

export default { setupSliders };
